import Api from "../../../services/api.service";
import {routes} from "../../../services/api.routes";
import {CharitySlots} from "../../../domain/CharitySlots";

export const updateAction = (data: CharitySlots): Promise<CharitySlots> => {
    //Todo: Handle if data is undefined or null
    return Api.$<CharitySlots>(routes.availability).update(data.id!, data)
}
